interface CampoTextoProps {
  id: string;
  name: string;
  label: string;
  help?: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  error?: string | null;
  type?: string;
  inputMode?: 'text' | 'email' | 'tel' | 'numeric' | 'decimal';
  placeholder?: string;
  autoComplete?: string;
  autoCapitalize?: string;
  autoFocus?: boolean;
  onBlur?: () => void;
}

export default function CampoTexto({
  id,
  name,
  label,
  help,
  value,
  onChange,
  required,
  error,
  type = 'text',
  inputMode = 'text',
  placeholder,
  autoComplete,
  autoCapitalize,
  autoFocus,
  onBlur,
}: CampoTextoProps) {
  return (
    <div>
      <label htmlFor={id} className="block text-base font-medium text-foreground-950">
        {label} {required && <span className="text-danger-600">*</span>}
      </label>
      {help && <p className="mt-1 text-sm text-secondary-500">{help}</p>}
      <input
        id={id}
        name={name}
        type={type}
        inputMode={inputMode}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete={autoComplete}
        autoCapitalize={autoCapitalize}
        autoFocus={autoFocus}
        onBlur={onBlur}
        className={`mt-1 w-full border-0 border-b bg-transparent px-0 py-2 text-[15px] text-foreground-950 outline-none transition-colors placeholder:text-secondary-400 focus:border-b-2 focus:border-primary-500 ${
          error ? 'border-danger-500' : 'border-secondary-300'
        }`}
      />
      {error && (
        <p className="mt-1 text-sm text-danger-600" role="alert" data-erro="true">
          {error}
        </p>
      )}
    </div>
  );
}